"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalContainer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _hooks = require("../hooks");

var _utils = require("../utils");

var _constants = require("./constants");

var _context2 = require("./context");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var modalContainerDefaultProps = {
  maxWidth: (0, _utils.px)(_utils.MEDIA_WIDTH)
};
var ModalContainer = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, externalRef) {
  var children = _ref.children,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? modalContainerDefaultProps.maxWidth : _ref$maxWidth;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      footerHasShadow = _useState2[0],
      setFooterHasShadow = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      headerHasShadow = _useState4[0],
      setHeaderHasShadow = _useState4[1];

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var screenEdgeGap = selectors.space(_constants.SCREEN_EDGE_GAP); // Fixing an iOS Safari-only issue where the header of the modal
  // is hidden behind the address bar.

  var _useUserAgent = (0, _hooks.useUserAgent)(),
      isIOSSafari = _useUserAgent.isIOSSafari;

  var _useViewportHeight = (0, _hooks.useViewportHeight)(isIOSSafari),
      viewportHeight = _useViewportHeight.vh;

  var maxHeightWithoutEdgeGap = "calc(100vh - ".concat((0, _utils.px)(screenEdgeGap * 2), ")");
  var maxHeight = isIOSSafari ? viewportHeight : maxHeightWithoutEdgeGap;
  var internalRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (internalRef.current) {
      var node = internalRef.current;
      setFooterHasShadow(node.scrollHeight > node.clientHeight);
    }
  }, []);

  var handleOnScroll = function handleOnScroll(e) {
    setHeaderHasShadow(e.currentTarget.scrollTop > 0);
    setFooterHasShadow(e.currentTarget.scrollTop + e.currentTarget.clientHeight < e.currentTarget.scrollHeight);
  };

  for (var _len = arguments.length, forwardedProps = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    forwardedProps[_key - 2] = arguments[_key];
  }

  return (0, _core.jsx)(_context2.ModalContext.Provider, {
    value: {
      footerHasShadow: footerHasShadow,
      headerHasShadow: headerHasShadow,
      setFooterHasShadow: setFooterHasShadow,
      setHeaderHasShadow: setHeaderHasShadow
    }
  }, (0, _core.jsx)(_helperComponents.ModalContainerWrapper, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
    backgroundColor: _constants.BACKGROUND_COLOR,
    dataTestComponent: "StencilModalContainer",
    ref: (0, _utils.mergeRefs)(externalRef, internalRef),
    maxWidth: maxWidth === null ? undefined : maxWidth,
    maxHeight: maxHeight,
    overflow: "auto",
    onScroll: handleOnScroll
  }), children));
});
exports.ModalContainer = ModalContainer;

var _default = (0, _utils.composeStencilComponent)({
  baseComponent: ModalContainer,
  description: 'Container component for modal header, body and footer.',
  displayName: 'ModalContainer',
  defaultProps: modalContainerDefaultProps,
  propTypes: {
    children: _stencilReactDesc.PropTypes.node.isRequired.description('Content to display in the modal, i.e modal header, body and footer.'),
    maxWidth: _stencilReactDesc.PropTypes.node.isRequired.description('Sets the maximum width of the modal.')
  }
});

exports.default = _default;